import React from 'react';
import { TimelineItemProps } from '../components/TimelineWrapper/TimelineWrapper';
import { ProductCarousel, ProductCarouselProps } from '@jbhi-fi/components/src/ProductCarousel/ProductCarousel';
import { ContentfulVideoTimestamp } from '@jbhi-fi/apis/src/contentful/types';
import { CollectionTransformer } from '@jbhi-fi/components/src/Contentful/transformers/CollectionTransformer';

import { CarouselTransformer } from '@jbhi-fi/components/src/Contentful/transformers/CarouselTransformer';
import { getStoreCurrency } from '../../../../utils/shopify/getStoreCurrency';

export const contentfulVideoTimestampToTimelineItemProps = (entry: ContentfulVideoTimestamp): TimelineItemProps => {
  const { fields } = entry;
  return {
    heading: fields?.heading ?? '',
    timestamp: fields?.timestamp ?? 0,
    children: (
      <ProductCarousel
        {...contentfulVideoTimestampToProductSourceProps(entry)}
        trackingListName={`STACK Video - ${fields?.heading ?? '(unnamed)'}`}
        shouldTrackImpressions
        renderProduct={({ hit, position }) => (
          <CarouselTransformer.ProductComponent
            hit={hit}
            position={position}
            trackingListName={fields?.heading ?? '(unnamed)'}
            trackingListPrefix={'Stack Video - '}
            trackingDescriptor={{
              page: 'STACK',
              currency: getStoreCurrency(),
              category: fields?.heading ?? '(unnamed)',
              group: fields?.heading ?? '(unnamed)',
            }}
          />
        )}
      />
    ),
  };
};

export const contentfulVideoTimestampToProductSourceProps = ({
  fields,
}: ContentfulVideoTimestamp): Partial<
  Pick<ProductCarouselProps, 'algoliaQuery' | 'productVariantIds' | 'productSkus'>
> => {
  switch (fields?.productSource) {
    case 'Collection':
      return fields.collection ? CollectionTransformer.toProductSourceProps(fields.collection) : {};
    case 'Products':
      return {
        productVariantIds: fields.products,
      };
    case 'Algolia':
      return {
        algoliaQuery: fields.algoliaQuery,
      };
    default:
      return {
        productVariantIds: fields?.products,
        algoliaQuery: fields?.algoliaQuery,
        ...(fields?.collection ? CollectionTransformer.toProductSourceProps(fields.collection) : {}),
      };
  }
};
